import {Component, Input, OnInit} from '@angular/core';
import {AnswerText} from '../../../data/models/test/answer';
import {AnsweredText} from '../../../data/models/result/answered-result';

@Component({
  selector: 'app-answered-text-result',
  templateUrl: './answered-text-result.component.html',
  styleUrls: ['./answered-text-result.component.css']
})
export class AnsweredTextResultComponent implements OnInit {

  @Input() testId!: number;
  @Input() testResultId!: number;
  @Input() testType!: string;
  @Input() answerText!: AnswerText;
  @Input() answeredText!: AnsweredText;

  constructor() {
  }

  ngOnInit(): void {
  }

}
